var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('Common')))]), _c('Config', {
    attrs: {
      "configName": "appTitleShowID",
      "title": _vm.$t('App Title Show ID')
    }
  }), _c('Config', {
    attrs: {
      "configName": "isHomePageFooterFixed",
      "title": _vm.$t('Footer Fixed')
    }
  }), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('QuickJump.QuickJump')))]), _c('Config', {
    attrs: {
      "configName": "QuickJump_ShowEvent",
      "title": _vm.$t('QuickJump.ShowEvent')
    }
  }), _c('Config', {
    attrs: {
      "configName": "QuickJump_ShowChangedWeapons",
      "title": _vm.$t('QuickJump.ShowChangedWeapons')
    }
  }), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Characters')))]), _c('Config', {
    attrs: {
      "configName": "characterShowMaxStatus",
      "title": _vm.$t('Character Show Max Status'),
      "subtitle": _vm.$t('Character Show Max Status Hint')
    }
  }), _c('Config', {
    attrs: {
      "configName": "characterTalentShowLuck",
      "title": _vm.$t('Character Talent Show Luck')
    }
  }), _c('Config', {
    attrs: {
      "configName": "characterIconFramed",
      "title": _vm.$t('Character Icon Framed')
    }
  }), _c('Config', {
    attrs: {
      "configName": "loadScenarioVoice",
      "title": _vm.$t('Load Scenario Voice')
    }
  }), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Quests')))]), _c('Config', {
    attrs: {
      "configName": "questDropsGrouped",
      "title": _vm.$t('Quest Drops Grouped')
    }
  }), _c('Config', {
    attrs: {
      "configName": "enemyAIPattern",
      "title": _vm.$t('Enemy AI Pattern')
    }
  }), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Clea')))]), _c('v-list-item', {
    on: {
      "click": _vm.reloadClea
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Show Clea On Start')))]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t('Show Clea On Start Hint')))])], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "readonly": ""
    },
    model: {
      value: _vm.$s.showCleaOnStart,
      callback: function callback($$v) {
        _vm.$set(_vm.$s, "showCleaOnStart", $$v);
      },
      expression: "$s.showCleaOnStart"
    }
  })], 1)], 1), _c('Config', {
    attrs: {
      "configName": "showCleaInDetailPage",
      "title": _vm.$t('Show Clea In Detail Page'),
      "subtitle": _vm.$t('Show Clea In Detail Page Hint')
    }
  }), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Database')))]), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Database Fetch Time')))])], 1), _c('v-list-item-action', [_c('v-list-item-action-text', [_vm._v(_vm._s(new Date(_vm.$store.state.$db.date).toLocaleString()))])], 1)], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Hash')))])], 1), _c('v-list-item-action', [_c('v-list-item-action-text', [_vm._v(_vm._s(_vm.$store.state.$db.version))])], 1)], 1), _c('v-list-item', {
    on: {
      "click": _vm.reloadDatabase
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Reload Database')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Application')))]), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Version')))])], 1), _c('v-list-item-action', [_c('v-list-item-action-text', [_vm._v(_vm._s(_vm.$version))])], 1)], 1), _c('v-list-item', {
    on: {
      "click": _vm.unregister
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Reload Application')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _vm.$i18n.locale != 'ja' ? [_c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Language')))]), _c('Config', {
    attrs: {
      "configName": "alwaysShowJapanese",
      "title": _vm.$t('Always Show Japanese')
    }
  }), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Package Fetch Time')))])], 1), _c('v-list-item-action', [_c('v-list-item-action-text', [_vm._v(_vm._s(new Date(_vm.translations.date).toLocaleString()))])], 1)], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {}
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Hash')))])], 1), _c('v-list-item-action', [_c('v-list-item-action-text', [_vm._v(_vm._s(_vm.translations.version))])], 1)], 1), _c('v-list-item', {
    on: {
      "click": _vm.reloadTranslations
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Reload Language Package')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-refresh")])], 1)], 1), _c('v-list-item', {
    attrs: {
      "href": _vm.$const.sites.translations,
      "target": "_blank"
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Help Translate Names')))])], 1), _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1)] : _vm._e(), _c('v-divider'), _c('v-subheader', [_vm._v(_vm._s(_vm.$t('Contact')))]), _c('Credit', {
    attrs: {
      "name": "林檎アメ"
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }